import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ItemHeaderDetails from "./ItemHeaderDetails"
import ItemMainDetails from "./ItemMainDetails"
import ItemHistories from "./ItemHistories"
import ItemPreviewDetails from "./ItemPreviewDetails"


class ItemDetails extends Component {
    render() {
        const {item} = this.props

        return (
            <div className="ItemDetails mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between">
                            <div className="Left">
                                <ItemHeaderDetails item={item}/>
                                <ItemMainDetails item={item}/>
                            </div>
                            <div className="Right">
                                <ItemPreviewDetails item={item}/>
                            </div>
                        </div>

                        <div className="Bottom">
                            <ItemHistories item={item}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

ItemDetails.propTypes = {
    item: PropTypes.object.isRequired,
}

export default ItemDetails
